import type { InputMode } from '@brighterly/lib-core-types/ui/inputs/types'

import { getMode } from '@shared/lib/mode'

import { useTutorApplicationStore } from '../store'

interface LegalAgreementsReturn {
  mode: ComputedRef<InputMode>
  label: string
  setAcceptNotRestrictedResident: () => void
}

export const useAcceptNotRestrictedResident = (): LegalAgreementsReturn => {
  const tutorApplicationStore = useTutorApplicationStore()

  const label = 'I confirm I am not a resident of the following territories: Russia, Crimea, Cuba, Lebanon, Venezuela, Iran, North Korea, Syria, Myanmar, Yemen, Pakistan and I can provide documentary proof.'

  const mode = computed(() => getMode(tutorApplicationStore.getShowErrors && !tutorApplicationStore.acceptNotRestrictedResident))

  const setAcceptNotRestrictedResident = (): void => {
    tutorApplicationStore.setAcceptNotRestrictedResident(!tutorApplicationStore.acceptNotRestrictedResident)
  }

  return {
    mode,
    label,
    setAcceptNotRestrictedResident,
  }
}
